/* web/style.css .popover */
.popover { position: fixed; z-index: 10; background: var(--surface); border-radius: var(--radius); box-shadow: var(--shadow-pop); padding: 16px; width: 280px; max-width: calc(100vw - 16px); animation: global(sheet-in) .18s var(--ease); }
.leaving { animation: global(sheet-out) .18s var(--ease) forwards; }
